<template>
  <TTooltip
    :class="`
      workbench-workpackage-tab
      ${disabled ? 'disabled-tab': '' }
      ${selected?`tab-selected ${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:'tab-non-selected'}
      `" 
    :style="`width: ${width};${disabled ? 'cursor: default;': 'cursor: pointer;' }`"
    :value="getToolTip()">
      <TIcon :name="tab.icon" :color="text_color" />
      <div v-if="selected && tab.text">{{tab.text}}</div>
  </TTooltip>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue'
import TTooltip from '@/components/Taktify/TTooltip.component.vue'
import {mapGetters} from 'vuex';
  export default {
    props: ['tab', 'width', 'selected', 'color', 'text_color', 'disabled'],
    components: {
      TIcon,
      TTooltip
    },
    computed: {
      ...mapGetters('View', [
        'isSvgIcon'
      ]),
    },
    methods: {
      getToolTip(){
        if (this.disabled) {
          return `${this.tab.type} are part of the TAKT.ing PRO.account.`;
        }
        return `${this.tab.type}`;
      }
    }
  }
</script>
<style>
  .workbench-workpackage-tab {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    border-radius: 3px 3px 0px 0px
  }
  .tab-selected {
    box-shadow:
      0px 0px 5px 0px rgba(0, 0, 0, 0.5)
      !important;
    z-index: 10;
  }
  .tab-non-selected {
    /* box-shadow:
      inset 0px 0px 5px 0px rgba(0, 0, 0, 0.5)
      !important; */
  }
  .disabled-tab {
    opacity: 0.5;
  }
</style>
